<template>
  <AppSubMenu
    :items="appState.menuItems"
    :menuActive="props.active"
    :isSlimOrHorizontalItemClick="props.isSlimOrHorizontalItemClick"
    :root="true"
    :parentMenuItemActive="true"
    :mobileMenuActive="props.mobileMenuActive" @menuitem-click="emit('menuitem-click', $event)"
    class="layout-menu" 
    @root-menuitem-click="emit('root-menuitem-click', $event)" />
</template>

<script setup>
import { inject } from "vue";
import AppSubMenu from "@/views/_app/AppSubMenu.vue";
const appState = inject("appState");
const emit = defineEmits(["menuitem-click", "root-menuitem-click"]);
const props = defineProps({
  active: Boolean,
  mobileMenuActive: Boolean,
  isSlimOrHorizontalItemClick: Boolean
});
</script>